module.exports = __webpack_public_path__ + "static/img/icon_szh_sdnl_yjkf.16ff2409.png";